import React, {useCallback, useEffect, useState} from 'react';

import {useCustomerMgr, useHistory, useLanguageDirection, useLocalesMgr, useUI} from 'coreHooks';
import {getIsInternalUrl} from 'coreUtils/url';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import AuthLogin from 'brandComponents/auth/AuthLogin';
import AuthRegisterForm from 'brandComponents/auth/AuthRegisterForm';
import Flyout from 'brandComponents/Flyout';
import {EFlyoutDirections} from 'brandComponents/Flyout/IFlyout';
import {SG_OPEN_REGISTER_FORM} from 'brandConstants';

import {EModes} from './IFlyoutAuth';

import styles from './FlyoutAuth.module.scss';

const FlyoutAuth = () => {
	const localesMgr = useLocalesMgr();
	const customer = useCustomerMgr().getCurrentCustomer();
	const isRegistered = customer.isRegistered;
	const isCustomerReady = customer.isReady();
	const {managerRepository} = useGeneralProvider();
	const [mode, setMode] = useState(EModes.SIGN_IN);
	const isRTL = useLanguageDirection().direction === 'rtl';
	const history = useHistory();
	const previousUrl = useUI('previousUrl');
	const isRequiresLogin = useUI('requiresLoginFeature');
	const isRequiresLoginEnabled = isRequiresLogin?.enabled || false;

	useEffect(() => {
		if (isRegistered && isCustomerReady) {
			managerRepository.getFlyoutsMgr().closeFlyout('login');
		}
	}, [isRegistered, isCustomerReady]);

	const onAfterClose = useCallback(() => {
		sessionStorage.removeItem(SG_OPEN_REGISTER_FORM);
		setMode(EModes.SIGN_IN);

		if (isRequiresLoginEnabled && !isRegistered) {
			const hasInternalReferrer = previousUrl && getIsInternalUrl(previousUrl);

			if (window.history.length > 1 && hasInternalReferrer && new URL(previousUrl).pathname !== window.location.pathname) {
				history.goBack();
			} else {
				history.push(localesMgr.updateLinkWithLocale('/'));
			}
		}
	}, [isRequiresLoginEnabled, isRegistered, history, localesMgr, previousUrl]);

	const onSuccess = useCallback(() => {
		managerRepository.getFlyoutsMgr().closeFlyout('login');
	}, []);

	return (
		<Flyout
			closeClassName={styles['flyout-auth__close']}
			flyoutClassName={styles['flyout-auth']}
			contentClassName={styles['flyout-auth__content']}
			id="login"
			direction={isRTL ? EFlyoutDirections.LEFT_TO_RIGHT : EFlyoutDirections.RIGHT_TO_LEFT}
			showCloseButton
			onAfterClose={onAfterClose}
		>
			<div className={styles['flyout-auth__wrapper']}>
				<div className={styles['flyout-auth__center']}>
					{mode === EModes.SIGN_IN && (
						<AuthLogin onCancel={() => setMode(EModes.SIGN_UP)} onSuccess={onSuccess}/>
					)}

					{mode === EModes.SIGN_UP && (
						<AuthRegisterForm onCancel={() => setMode(EModes.SIGN_IN)} onSuccess={onSuccess}/>
					)}
				</div>
			</div>
		</Flyout>
	);
};

export default FlyoutAuth;
